import { IModel } from 'core-ts-types';
import { ISectionWaitlistPosition } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
interface IRegistrationWaitlistPositionModel {
  waitlist_positions: Record<string, ISectionWaitlistPosition>;
}
export class RegistrationWaitlistPositionModel implements IModel {
  private _model: IRegistrationWaitlistPositionModel = {
    waitlist_positions: {}
  };

  clear(): RegistrationWaitlistPositionModel {
    this._model.waitlist_positions = {};
    return this;
  }
  write() {
    return this;
  }
  put(sectionWaitlistPosition: ISectionWaitlistPosition): RegistrationWaitlistPositionModel {
    this._model.waitlist_positions[sectionWaitlistPosition.section] = sectionWaitlistPosition;
    return this;
  }

  read(): IRegistrationWaitlistPositionModel {
    return this._model;
  }
  get(sectionId: number) {
    return _4.find(this._model.waitlist_positions, (position) => position.section === sectionId);
  }

  refresh() {
    return this;
  }
  update() {
    return this;
  }
}

angular
  .module('capability-ng-scheduler')
  .service('ngRegistrationWaitlistPositionModel', RegistrationWaitlistPositionModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/models/registration_waitlist_position_model.ts